// SS-4258: the booking fields and the placements each one allows are owned by the api
// (helpers/bookingFieldPlacements.js), which validates every settings save against
// them and serves them on GET /settings/ai as `booking_field_definitions`. The
// Customize-AI controls read that list, so a placement the screen offers is exactly
// one the api will store.
//
// FALLBACK_DEFINITIONS is only used until the api's list has been received (a page
// that renders before any GET /settings/ai) or against an api that predates it. It
// mirrors the api list; the api's copy wins whenever it is present.
//
// states: which placements a field supports. "during" = required array (asked,
// books anyway); "must" = blocker array (booking is refused until answered; for
// insurance name/type this also collects before times are offered); "after" =
// optional array (asked once booked).
// insurance_subscriber_id is a legacy ALIAS of insurance_policy_number — the card
// carries one identifier; configuring both keys double-gates one value.
// dependsOn: prerequisites that must ALSO be collected — a detail is meaningless
// without the payer name, and the policyholder DOB without the policyholder question.
const FALLBACK_DEFINITIONS = [
  { field: "insurance_name", group: "insurance_core", label: "Insurance name", states: ["during", "must"] },
  { field: "insurance_type", group: "insurance_core", label: "Plan type (HMO / PPO)", states: ["during", "must"] },
  { field: "insurance_policy_number", group: "insurance_detail", aliases: ["insurance_subscriber_id"], label: "Member ID / policy number", dependsOn: ["insurance_name"], states: ["during", "must", "after"] },
  { field: "insurance_group_number", group: "insurance_detail", label: "Group number", dependsOn: ["insurance_name"], states: ["during", "must", "after"] },
  { field: "insurance_plan_number", group: "insurance_detail", label: "Plan number", dependsOn: ["insurance_name"], states: ["during", "must", "after"] },
  { field: "insurance_employer", group: "insurance_detail", label: "Employer the plan is through", dependsOn: ["insurance_name"], states: ["during", "must", "after"] },
  { field: "insurance_policyholder_name", group: "insurance_detail", label: "Is the insurance under the patient or another person (collects that person's name)", dependsOn: ["insurance_name"], states: ["during", "must", "after"] },
  { field: "insurance_policyholder_birth_date", group: "insurance_detail", label: "Policyholder / guardian date of birth (asked only when it is not the patient)", dependsOn: ["insurance_name", "insurance_policyholder_name"], states: ["during", "must", "after"] },
  // SSN is deliberately after-only: never enforced, never asked during a call.
  { field: "patient_social_security_number", group: "contact", label: "Social Security number", states: ["after"] },
  { field: "patient_address", group: "contact", label: "Home address", states: ["after", "during", "must"] },
  { field: "patient_city", group: "contact", label: "City", states: ["after", "during", "must"] },
  { field: "patient_state", group: "contact", label: "State", states: ["after", "during", "must"] },
  { field: "patient_zip", group: "contact", label: "ZIP code", states: ["after", "during", "must"] },
  { field: "patient_email", group: "contact", label: "Email address", states: ["after", "during", "must"] },
];

const PLACEMENTS = ["during", "must", "after"];
let served = null;

const isUsable = (defs) => Array.isArray(defs) && defs.length > 0 && defs.every(d =>
  d && typeof d.field === "string" && typeof d.label === "string" && typeof d.group === "string"
  && Array.isArray(d.states) && d.states.length > 0 && d.states.every(s => PLACEMENTS.includes(s)));

// Called with GET /settings/ai's `booking_field_definitions` by the pages that load the settings.
export const rememberBookingFieldDefinitions = (defs) => {
  if (isUsable(defs)) served = defs;
};

export const bookingFieldDefinitions = () => served || FALLBACK_DEFINITIONS;

export const bookingFieldsInGroup = (group) => bookingFieldDefinitions().filter(d => d.group === group);

// Test seam: forget the api's list.
export const resetBookingFieldDefinitions = () => { served = null; };
